import React from 'react';
import { useParams } from 'react-router-dom';
import { CatalogForm } from '../../../components/CatalogForm/CatalogForm';
import { GiroService } from '../../../services/GiroService';
import { Validators } from '../../../components/CatalogForm/validators';

const formFields = [
  {
    name: 'giro',
    label: 'Clave',
    type: 'text',
    col: 4,
    placeholder: 'Ej. IND',
    validators: [
      Validators.required("La clave es obligatoria")
    ],
  },
  {
    name: 'giro_nombre',
    label: 'Descripción',
    type: 'text',
    col: 8,
    placeholder: 'Ej. Industrial y Manufactura',
    validators: [
      Validators.required("La descripción es obligatoria")
    ],
  },
];

export const GiroForm = () => {
  const { id } = useParams();

  const handleLoadData = async (recordId) => {
    return await GiroService.obtenerPorId(recordId);
  };

  const handleSubmit = async (values) => {
    return await GiroService.guardar(values);
  };

  return (
    <CatalogForm
      title="Giro Comercial"
      subtitle="Clasificación de giros de negocio para clientes"
      fields={formFields}
      id={id}
      loadData={handleLoadData}
      onSubmit={handleSubmit}
      backUrl="/Catalogo/Giros"
    />
  );
};

export default GiroForm;
